import { RebateProgress } from "@/gql/graphql";
import { cssColor } from "@stenajs-webui/theme";
import { isSuggestedOnSameTargetAsExpected } from "./progressiveRebateValidation";

const GREEN_CELL_BG = cssColor("--lhds-color-green-100");
const RED_CELL_BG = cssColor("--lhds-color-red-100");
const ORANGE_CELL_BG = cssColor("--lhds-color-orange-100");

export const resolveCompletionBackgroundColor = (
  item: RebateProgress
): string => {
  const onSameTarget = isSuggestedOnSameTargetAsExpected(
    item.displayedTarget,
    item.expectedVolume ?? 0,
    item.suggestedExpectedVolume
  );

  if (!onSameTarget) {
    return RED_CELL_BG;
  }

  const completionPercent = item.completionPercent;

  if (completionPercent > 95) {
    return GREEN_CELL_BG;
  }

  if (completionPercent >= 85) {
    return ORANGE_CELL_BG;
  }

  return RED_CELL_BG;
};

export const resolvePeriodSortValue = (
  period: number | undefined,
  rebateTermCode: string | undefined
) => {
  if (rebateTermCode === "USER_DEF") {
    return 500;
  }
  if (rebateTermCode === "YEARLY") {
    return 400;
  }
  if (rebateTermCode === "HALF_YEAR") {
    return 300 + (period ?? 0);
  }
  if (rebateTermCode === "QUARTERLY") {
    return 200 + (period ?? 0);
  }
  if (rebateTermCode === "MONTHLY") {
    return 100 + (period ?? 0);
  }

  return period;
};
